import LocationProps from "../props/LocationProps";
import { ICombinedLocations } from "./type";
import { getDataFromCMS } from "../helpers";

const transformLocationsToArray = (locations:string, type:string = 'crc') => {
  const transformedLocations:LocationProps[] = []
  Object.values(JSON.parse(locations)).forEach((location) => {
    const loc = location as LocationProps
    loc.type = type
    loc.active = true
    transformedLocations.push(loc)
  })

  return transformedLocations
}

const combinedLocations = (locations:LocationProps[]) => {
  // need to make a multi-dimensional array where there can be two of the same location and they are one entry.
  // probably easier just to make it all arrays, just of single or multiple lengths.
  const combinedLocations:ICombinedLocations = {}
  locations.forEach((loc:LocationProps) => {
    // get a combination of the lat and lng to make one unique number across the locations.
    const combinedLatLng = `${Math.abs(loc.location.lat).toString()}${Math.abs(loc.location.lng).toString()}`.replace(/\./g, '')
    if (!combinedLocations[combinedLatLng]) {
      combinedLocations[combinedLatLng] = {
        type: loc.type,
        locations: [loc]
      }
    } else {
      combinedLocations[combinedLatLng].locations.push(loc)
      if (combinedLocations[combinedLatLng].locations.every(item => item.type === combinedLocations[combinedLatLng].locations[0].type)) {
        // if there are multiple pins of the same type at the same place
        // this should never happen, but it's nice to be sure.
          combinedLocations[combinedLatLng].type = combinedLocations[combinedLatLng].locations[0].type
      } else {
        combinedLocations[combinedLatLng].type = 'mixed'
      }
    }
  })

  // console.log(combinedLocations)
  return combinedLocations
}

export {
  getDataFromCMS,
  combinedLocations,
  transformLocationsToArray
}
